
<template>
  <vs-row class="my-5">
    <vs-col>
      <h6 class="font-bold mb-4">{{ $te('filters.' + filter.title + '.title')?$t('filters.' + filter.title + '.title'):filter.title }}</h6>
      <div>
        <ul>
          <template v-for="(terms, groupName) in groups">
            <li :key="groupName" v-if="groupName" class="mb-2 ml-3 flex items-center justify-between font-semibold">
              <span>{{groupName}}</span>
            </li>
            <li v-for="(term, index) in terms" :key="`${groupName}-${index}`" class="mb-2 flex items-center justify-between" :class="groupName ? 'ml-6' : ''">
              <vs-checkbox color="success"
                           v-model="selected"
                           :vs-value="term.value">
                <span v-if="term.translate" :class="{'text-success':isSelected(term)}">{{$t('filters.' + filter.title + '.values.' + term.label)}}</span>
                <span v-else :class="{'text-success':isSelected(term)}">{{term.label}}</span>
              </vs-checkbox>
              <span>{{ term.count }}</span>
            </li>
          </template>
        </ul>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>


export default {
  name: 'sm-hateoas-filter-terms',
  props: {
    filter: {
      type: Object,
      default () {
        return {
          id: null,
          title: null,
          terms: []
        };
      }
    }
  },
  data () {
    return {
      selected: this.filter.terms.filter(t => t.selected).map(t => t.value)
    };
  },
  computed: {
    groups () {
      return Object.groupBy(this.filter.terms, ({group}) => group || '');
    }
  },
  watch: {
    selected: {
      immediate: true,
      handler (value) {
        this.$emit('change', value);
      }
    }
  },
  methods: {
    isSelected (term) {
      return this.selected.indexOf(term.value) >= 0;
    }
  }
};
</script>

<style scoped>

</style>
